<div class="event-monitor-shell">
  <button type="button" class="header-action header-action-icon" title="Eventi live" aria-haspopup="dialog" (click)="toggleDialog()">
    <fa-icon [icon]="['fas', 'chart-line']" aria-hidden="true"></fa-icon>
  </button>

  <p-dialog [(visible)]="showDialog" [modal]="true" [closable]="true" [draggable]="false" [resizable]="false"
    ariaLabelledBy="event-monitor-title"
    [style]="{ width: '92vw', maxWidth: '1400px', height: '78vh' }"
    (onHide)="closeDialog()">
    <ng-template pTemplate="header">
      <div class="event-monitor-header">
        <span id="event-monitor-title">Event monitor live</span>
        <button type="button" class="inline-flex items-center justify-center gap-2 px-3 py-1 text-xs font-semibold rounded border border-white text-white hover:bg-white hover:text-fq-secondary cursor-pointer transition-all" (click)="clearEvents()">
          <fa-icon [icon]="['fas', 'trash']" aria-hidden="true"></fa-icon> Pulisci
        </button>
      </div>
    </ng-template>

    @if (events().length) {
      <div class="event-gantt-shell">
        <div class="event-gantt-header">
          <div class="event-gantt-label-col">Task / Hierarchy</div>
          <div class="event-gantt-timeline-col">
            <div class="event-gantt-scale">
              @for (tick of timelineTicks(); track $index) {
                <span>{{ tick }}</span>
              }
            </div>
          </div>
        </div>
        <div class="event-gantt-body">
          @for (event of events(); track trackEvent($index, event)) {
            <div class="event-gantt-row"
              [ngClass]="event.ganttRowClass"
              [style.--row-color]="event.categoryColor"
              [title]="buildEventTooltip(event)">
              <div class="event-gantt-label" [style.paddingLeft.px]="event.depth * 18 + 8">
                <div class="event-gantt-name">
                  <span class="event-gantt-row-icon" [ngClass]="event.eventType === 'child' ? 'is-child' : 'is-parent'"></span>
                  {{ event.eventName }}
                </div>
                <div class="event-gantt-subline">
                  <span class="event-gantt-group">{{ event.eventGroup }}</span>
                  <span class="event-gantt-type" [ngClass]="event.statusClass">{{ event.status }}</span>
                  <span class="event-gantt-meta">{{ event.source }} · {{ event.createdAt | date:'HH:mm:ss' }}</span>
                </div>
              </div>
              <div class="event-gantt-track-wrap">
                <div class="event-gantt-track">
                  <div class="event-gantt-grid">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                  @if (!event.isMilestone) {
                    <div class="event-gantt-bar"
                      [style.left.%]="event.ganttLeftPct"
                      [style.width.%]="event.ganttWidthPct"
                      [style.backgroundColor]="event.categoryColor">
                      <div class="event-gantt-bar-fill" [style.width.%]="event.progressPct"></div>
                      @if (event.ganttWidthPct > 12) {
                        <div class="event-gantt-bar-content">
                          <span class="event-gantt-bar-label">{{ event.eventName }}</span>
                          <span class="event-gantt-bar-progress">{{ event.progressPct }}%</span>
                        </div>
                      }
                    </div>
                  } @else {
                    <div class="event-gantt-milestone" [style.left.%]="event.ganttLeftPct" [title]="buildEventTooltip(event)"></div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    } @else {
      <div class="empty-state">
        <fa-icon [icon]="['fas', 'hourglass-half']" aria-hidden="true"></fa-icon>
        <div>Nessun evento ricevuto ancora.</div>
        <div class="empty-state-hint">Quando arrivano eventi, verranno mostrati come barre temporali impilate.</div>
      </div>
    }

  </p-dialog>
</div>
